import React from 'react';
import {
  DateTime,
} from 'luxon';
import {
  Link,
} from 'react-router-dom';

import * as S from '../../styled';

const formatDate = (isoDay, f) => DateTime.fromISO(isoDay).toFormat(f);

type Props = {
  features: {
    results: boolean,
  },
  workouts: any[],
  withStatus: boolean,
};

const Table = ({ workouts, withStatus, features }: Props) => (
  <table>
    <thead>
      <tr>
        <th>Workout</th>
        <th>Date</th>
        <th>Time</th>
        {withStatus && (
          <th>Status</th>
        )}
      </tr>
    </thead>
    <tbody>
      {workouts.map(ev => (
        <tr key={ev.id}>
          <td>
            {features.results ? (
              <Link to={`/events/${ev.id}`}>
                <S.LinkLabel>
                  {ev.workout_name}
                </S.LinkLabel>
              </Link>
            ) : (
              <S.LinkLabel>
                {ev.workout_name}
              </S.LinkLabel>
            )}
          </td>
          <td>{formatDate(ev.begins_at, 'MMM dd')}</td>
          <td>{formatDate(ev.begins_at, 'T')}</td>
          {withStatus && (
            <td>
              {ev.is_completed ? (
                <S.WorkoutComplete />
              ) : (
                <S.WorkoutInComplete />
              )}
            </td>
          )}
        </tr>
      ))}
    </tbody>
  </table>

);

export default Table;
